import React from 'react'
import { Button, Typography } from '@mui/material'
import FullscreenOverlay from 'components/common/FullscreenOverlay'
import MiniGamePanel from './MiniGamePanel'

type FunGameModalProps = {
  open: boolean
  onClose: () => void
}

const FunGameModal = ({ open, onClose }: FunGameModalProps) => {
  if (!open) return null

  return (
    <FullscreenOverlay
      open={open}
      onClose={onClose}
      ariaLabelledBy="fun-game-modal-title"
      contentSx={{ maxWidth: 1100 }}
    >
      <Typography
        id="fun-game-modal-title"
        variant="h6"
        sx={{ fontWeight: 700, mb: 1 }}
      >
        Fun Area
      </Typography>

      <MiniGamePanel running={open} />

      <Button
        onClick={onClose}
        variant="text"
      >
        Fermer
      </Button>
    </FullscreenOverlay>
  )
}

export default FunGameModal
